<template>
  <div
    id="map"
    ref="mapContainer"
    @contextmenu="
      () => {
        return false;
      }
    "
  >
    <div id="map-container">
      <div id="map" ref="map"></div>
      <canvas
        id="deck-canvas"
        ref="canvas"
        :class="[{ 'drag-cursor': showMeasureTool }]"
        @contextmenu.prevent="
          () => {
            return false;
          }
        "
      ></canvas>
    </div>
    <GeoPopup
      v-if="popupData && popupData.show"
      :title="popupData.title"
      :value="popupData.value"
      :icon="popupData.icon"
      :metadata="popupData.metadata"
      :x="popupData.x"
      :y="popupData.y"
    />
    <ContextMenu
      :data="getContextData"
      @close="closeContext"
      @addComment="(data) => showAddCommentPopup(data)"
    />
    <CommentView />
    <CommentBox />
    <SlideYUpTransition>
      <MessageBox v-if="showMeasureTool" />
    </SlideYUpTransition>
    <transition name="fade">
      <div v-if="!mapLoaded" class="loader-background">
        <SpaceLoader />
        <p>{{ getRandomMessage }}</p>
      </div>
    </transition>
  </div>
</template>

<script>
import { Deck, WebMercatorViewport } from "@deck.gl/core";
import mapboxgl from "mapbox-gl";
import { mapActions, mapGetters } from "vuex";
import GeoPopup from "@/modules/GeoPopup";
import SpaceLoader from "@/components/global/views/SpaceLoader";
import ContextMenu from "@/components/global/views/ContextMenu";
import MessageBox from "@/components/metrics/views/MessageBox";
import { SlideYUpTransition } from "vue2-transitions";
import debounce from "lodash/debounce";
import CommentBox from "@/components/global/views/CommentBox";
import CommentView from "@/components/global/views/CommentView";

let MapboxMap = null;
const messages = [
  "Positioning Satellites...",
  "Getting the maps ready...",
  "Waiting for the stars to align...",
  "Searching for satellites...",
  "Looking for oceans...",
];

export default {
  components: {
    GeoPopup,
    SpaceLoader,
    ContextMenu,
    MessageBox,
    SlideYUpTransition,
    CommentBox,
    CommentView,
  },
  props: {
    secondary: Boolean,
    geoData: Object,
    staticLayers: Array,
    popupData: Object,
    mapStyle: String,
    type: String,
  },
  data() {
    return {
      mapLoaded: false,
      longitude: 74.824405,
      latitude: 12.8995158,
      zoom: 5,
      bearing: 0,
      pitch: 0,
      transitionDuration: 500,
      commentData: null,
    };
  },
  computed: {
    ...mapGetters("Map", [
      "getZoom",
      "isTilted",
      "getGridFilter",
      "getMapFilters",
      "getViewState",
      "getOverlays",
      "getContextData",
      "getMeasureData",
      "showMeasureTool",
      "getOpacity",
    ]),
    ...mapGetters("Comments", ["getComments"]),
    ...mapGetters("Location", ["getActiveLocation", "getActiveCity"]),
    getRandomMessage() {
      const randomMessage =
        messages[Math.floor(Math.random() * messages.length)];
      return randomMessage;
    },
    // mPopupData() {
    //   if (this.type) {
    //     try {
    //       return this.getPopups.find(item => item.type === this.type);
    //     } catch (error) {
    //       console.error(error);
    //     }
    //   } else {
    //     return this.popupData;
    //   }
    // },
  },
  methods: {
    ...mapActions("Map", [
      "setMap",
      "setGridSource",
      "setLayerData",
      "zoomIn",
      "zoomOut",
      "setZoom",
      "toggleTilt",
      "setViewState",
      "setContextData",
    ]),
    ...mapActions("Comments", ["setEditComment"]),
    renderViz() {
      this.deck.setProps({
        layers: this.getLayers(),
      });
    },
    closeContext() {
      this.setContextData({ show: false });
    },
    setInitialZoom() {
      if (this.getActiveCity) {
        this.updateViewStateWithCity(this.getActiveCity);
      } else {
        this.deck.setProps({
          viewState: {
            latitude: this.getViewState.latitude,
            longitude: this.getViewState.longitude,
            zoom: 12,
            bearing: this.getViewState.bearing,
            pitch: this.getViewState.pitch,
            transitionDuration: 500,
          },
        });
      }
    },
    showAddCommentPopup(data) {
      this.setEditComment(data);
      // this.commentData = data;
    },
    getView() {
      return this.getViewState;
    },
    handleZoom(e) {
      //this.setZoom(e.map.getZoom());
    },
    async loadLayer() {
      if (!this.map) return;
      let layerData = null;
      if (this.geoData && this.geoData.data) {
        layerData = {
          map: this.map,
          deck: this.deck,
          layer_id: "metric_base_layer",
          data: this.geoData.data,
          layer_type: this.geoData.entity_type,
          type: this.type,
          filter: this.filter,
        };
      } else {
        layerData = {
          map: this.map,
          deck: this.deck,
          layer_id: "metric_base_layer",
          data: null,
          layer_type: null,
          type: this.type,
        };
      }

      this.setLayerData({
        layerData,
        viewState: this.getViewState,
        staticLayerData: this.staticLayers,
      })
        .then((data) => {
          // layer updated
          //this.map.resize();
          console.log({ data });
        })
        .catch((error) => {
          // unable to set the layer
        });
    },
    updateViewStateWithCity(city) {
      const viewPort = new WebMercatorViewport(this.getViewState);
      const { longitude, latitude, zoom } = viewPort.fitBounds(city.bbox);
      this.deck.setProps({
        viewState: {
          latitude,
          longitude,
          zoom: 9,
          bearing: this.getViewState.bearing,
          pitch: this.getViewState.pitch,
          transitionDuration: 1500,
        },
      });
    },
    jumpToLocation(latlong) {
      this.deck.setProps({
        viewState: {
          latitude: latlong[0],
          longitude: latlong[1],
          zoom: this.getViewState.zoom,
          bearing: this.getViewState.bearing,
          pitch: this.getViewState.pitch,
          transitionDuration: 1500,
        },
      });
    },
  },
  watch: {
    /**
     * @param {City} city
     */
    // getActiveCity(city) {
    //   if (!city) return;
    //   this.updateViewStateWithCity(city);
    // },
    getActiveLocation(latlong) {
      this.jumpToLocation(latlong);
    },
    isTilted(value) {
      if (value) {
        this.deck.setProps({
          viewState: {
            latitude: this.getViewState.latitude,
            longitude: this.getViewState.longitude,
            zoom: this.getViewState.zoom,
            bearing: this.getViewState.bearing,
            pitch: 60,
            transitionDuration: 500,
          },
        });
      } else {
        this.deck.setProps({
          viewState: {
            latitude: this.getViewState.latitude,
            longitude: this.getViewState.longitude,
            zoom: this.getViewState.zoom,
            bearing: this.getViewState.bearing,
            pitch: 0,
            transitionDuration: 500,
          },
        });
      }
    },
    staticLayers() {
      this.loadLayer();
    },
    getMeasureData() {
      this.loadLayer();
    },
    showMeasureTool() {
      this.loadLayer();
    },
    getZoom(value) {
      const viewState = {
        latitude: this.getViewState.latitude,
        longitude: this.getViewState.longitude,
        zoom: value,
        bearing: this.getViewState.bearing,
        pitch: this.getViewState.pitch,
        transitionDuration: 500,
      };
      this.deck.setProps({
        viewState,
      });
    },
    getComments() {
      this.loadLayer();
    },
    geoData(value) {
      this.loadLayer();
    },
    getOpacity(value) {
      this.loadLayer();
    },
    getGridFilter(value) {
      this.loadLayer();
    },
    getMapFilters() {
      this.loadLayer();
    },
    mapStyle(value) {
      this.map.setStyle(value);
    },
  },

  created() {
    // non reactive map component
    this.map = null;
    this.debouncedViewStateUpdate = debounce(this.setViewState, 500);
  },
  mounted() {
    this.map = new mapboxgl.Map({
      accessToken:
        "pk.eyJ1IjoiaGF4emllIiwiYSI6ImNqZ2c2NWp3OTBxenAzM3FzeThydmZ0YncifQ.584ugILuKFfDPTxqyiO_0g",
      container: this.$refs.map,
      interactive: false,
      style: this.mapStyle,
      center: [this.getViewState.longitude, this.getViewState.latitude],
      zoom: this.getViewState.zoom,
      bearing: this.getViewState.bearing,
      pitch: this.isTilted ? this.getViewState.pitch : 0,
    });

    this.deck = new Deck({
      canvas: this.$refs.canvas,
      width: "100%",
      height: "100%",
      initialViewState: this.getViewState,
      controller: true,
      onViewStateChange: ({ viewState }) => {
        this.map.jumpTo({
          center: [viewState.longitude, viewState.latitude],
          zoom: viewState.zoom,
          bearing: viewState.bearing,
          pitch: viewState.pitch,
        });
        this.debouncedViewStateUpdate(viewState);
      },
      onClick: (info, event) => {
        // set context menu data
        if (event && event.rightButton) {
          console.log({ info });
          const { coordinate, x, y } = info;
          this.setContextData({
            x,
            y,
            data: {
              coordinate,
            },
            show: true,
          });
        } else {
          this.setContextData({ show: false });
        }
      },
    });
    this.map.on("load", (e) => {
      this.mapLoaded = true;
      this.map.resize();
      this.loadLayer();
      // this.setInitialZoom();
      setTimeout(() => {
        this.setInitialZoom();
      }, 1000);
    });
  },
};
</script>

<style lang="scss" scoped>
#map {
  position: relative;
  width: 100%;
  height: 100%;
  background: #e5e9ec;
  overflow: hidden;
}

#map-container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.drag-cursor {
  cursor: crosshair !important;
}

#map-container > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.loader-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: var(--color-default-background);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  p {
    opacity: 0.7;
  }
}

.map-popup {
  background: var(--color-secondary-light);
  padding: 10px;
  border-radius: 5px;
  color: var(--font-color);
  bottom: 30px;
  position: absolute;
  min-width: 200px;
  transition: 0.3s all ease-in-out;

  .metric {
    font-size: 1.2em;
    text-transform: capitalize;
  }

  .title {
    font-size: 1em;
    opacity: 0.6;
  }

  .description {
    color: var(--color-primary);
  }

  .value {
    margin: 0;
    font-size: 2em;
    font-weight: bold;
    line-height: 1em;
    padding: 10px 0;
  }

  &:after {
    position: absolute;
    content: "";
    bottom: 10px;
    left: 0;
    right: 0;
    width: 0;
    height: 0;
    border: 10px solid transparent;
    border-top-color: var(--color-secondary-light);
    border-bottom: 0;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: -20px;
  }
}
</style>
